<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
import { ReleaseRiskTypeMethods } from '@state/modules/release-risk-type'
import { ReleaseReasonTypeMethods } from '@state/modules/release-reason-type'
import { ReleaseTypeMethods } from '@state/modules/release-type'
// import { LicenseComputed } from '@state/modules/license'
export default {
  name: 'ReleaseManagementModule',
  page() {
    return {
      title: `${this.$tc('release_management')}`,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (from.name && from.name.indexOf('risk-type') >= 0) {
      this.fetchReleaseRiskTypes()
    }
    if (from.name && from.name.indexOf('reason-type') >= 0) {
      this.fetchReleaseReasonTypes()
    }
    if (from.name && from.name.indexOf('release-type') >= 0) {
      this.fetchReleaseTypes()
    }
    next()
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...PreferenceComputed,
    // ...LicenseComputed,
  },
  created() {
    if (this.myAllowedModules.indexOf('admin.release_management') === -1) {
      return this.$router.replace({ name: '404' })
    }
    this.hasPermission = true
  },
  // TO DO: Will do in pre-7.5
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     if (vm.availableModulesInLicense.indexOf(vm.$constants.RELEASE) === -1) {
  //       return vm.$router.replace({ name: 'upgrade-plan' })
  //     }
  //     if (vm.myAllowedModules.indexOf(vm.$constants.RELEASE) === -1) {
  //       return vm.$router.replace({ name: '404' })
  //     }
  //   })
  // },
  methods: {
    ...ReleaseRiskTypeMethods,
    ...ReleaseReasonTypeMethods,
    ...ReleaseTypeMethods,
  },
}
</script>
